module.exports = __webpack_public_path__ + "assets/32d2c72b1ce9f6828f233b4ade95cfb1.svg";